const TextInputName = ({ value, onChange }) => {
  return (
    <div>
      <label 
        className="block text-gray-700 mb-2" 
        htmlFor="name"
      >
        Nama Lengkap
      </label>
      <input
        type="text"
        id="name"
        name="name"
        value={value}
        onChange={onChange}
        placeholder="Masukkan nama lengkap Anda"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
        required
      />
    </div>
  )
}

export default TextInputName